// AuthContext.js - Updated to work with UserManagement
import { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  // Check for existing token on component mount
  useEffect(() => {
    const checkToken = async () => {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      
      if (token) {
        try {
          setIsLoggedIn(true);
          // Set user with admin permissions for now
          setUser({ 
            id: 1,
            name: 'Admin',
            email: 'admin@example.com',
            is_staff: true,
            is_verified: true,
            is_active: true
          });
        } catch (error) {
          console.error('Token validation error:', error);
          localStorage.removeItem('token');
          setIsLoggedIn(false);
        }
      }
      
      setIsLoading(false);
    };
    
    checkToken();
  }, []);

  const login = (userData) => {
    setIsLoggedIn(true);
    if (userData) {
      setUser(userData);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUser(null);
    window.location.href = '/'; 
  };

  // Add the missing hasPermission function
  const hasPermission = (permission) => {
    if (!user) return false;
    
    // For now, if user is logged in and is_staff, grant all permissions
    // You can customize this logic based on your needs
    if (user.is_staff) return true;
    
    // Add specific permission logic here
    switch (permission) {
      case 'manage_users':
        return user.is_staff || user.is_admin;
      case 'view_users':
        return user.is_staff || user.is_verified;
      case 'edit_profile':
        return true; // All authenticated users can edit their profile
      default:
        return false;
    }
  };

  // Add the missing hasRole function
  const hasRole = (role) => {
    if (!user) return false;
    
    switch (role) {
      case 'admin':
        return user.is_staff || user.is_superuser;
      case 'staff':
        return user.is_staff;
      case 'verified':
        return user.is_verified;
      case 'active':
        return user.is_active;
      default:
        return false;
    }
  };

  // Get user's display name
  const getDisplayName = () => {
    if (!user) return 'Guest';
    return user.name || user.email || 'User';
  };

  // Get user's initials for avatar
  const getUserInitials = () => {
    if (!user) return 'G';
    
    if (user.name) {
      const names = user.name.split(' ');
      return names.map(name => name.charAt(0)).join('').toUpperCase().slice(0, 2);
    }
    
    return user.email ? user.email.charAt(0).toUpperCase() : 'U';
  };

  const value = {
    // Your existing values
    isLoggedIn,
    isLoading,
    user,
    login,
    logout,
    
    // New functions needed by UserManagement
    hasPermission,
    hasRole,
    getDisplayName,
    getUserInitials,
    
    // Auth state
    isAuthenticated: isLoggedIn,
    token: localStorage.getItem('token')
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// import { createContext, useState, useContext, useEffect } from 'react';

// const AuthContext = createContext();

// export const useAuth = () => {
//   return useContext(AuthContext);
// };

// export const AuthProvider = ({ children }) => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [user, setUser] = useState(null);

//   // Check for existing token on component mount
//   useEffect(() => {
//     const checkToken = async () => {
//       setIsLoading(true);
//       const token = localStorage.getItem('token');
      
//       if (token) {
//         try {
         
//           setIsLoggedIn(true);
          
//           setUser({ name: 'Admin' });
//         } catch (error) {
//           console.error('Token validation error:', error);
//           localStorage.removeItem('token');
//           setIsLoggedIn(false);
//         }
//       }
      
//       setIsLoading(false);
//     };
    
//     checkToken();
//   }, []);

//   const login = (userData) => {
//     setIsLoggedIn(true);
//     if (userData) {
//       setUser(userData);
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     setIsLoggedIn(false);
//     setUser(null);
//     window.location.href = '/'; 
//   };

//   const value = {
//     isLoggedIn,
//     isLoading,
//     user,
//     login,
//     logout
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };